/**
 * @generated SignedSource<<43c31c7c10a6fa2abe23218f8e55b638>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type EmployeeWorkStatus = "NOT_WORKING" | "WORKING";
import { FragmentRefs } from "relay-runtime";
export type ToolbarButtonAssignees_employees$data = ReadonlyArray<{
  readonly id: string;
  readonly isLinkedToViewer: boolean;
  readonly name: string;
  readonly workStatus: EmployeeWorkStatus;
  readonly " $fragmentSpreads": FragmentRefs<"Avatar_employee">;
  readonly " $fragmentType": "ToolbarButtonAssignees_employees";
}>;
export type ToolbarButtonAssignees_employees$key = ReadonlyArray<{
  readonly " $data"?: ToolbarButtonAssignees_employees$data;
  readonly " $fragmentSpreads": FragmentRefs<"ToolbarButtonAssignees_employees">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "ToolbarButtonAssignees_employees",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isLinkedToViewer",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "workStatus",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Avatar_employee"
    }
  ],
  "type": "Employee",
  "abstractKey": null
};

(node as any).hash = "5ac28ddabe2d0cdeef8f63c59fda0622";

export default node;
